(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["peso-home-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('peso-home-motion')) {
    class PesoHomeMotion extends HTMLElement {
      connectedCallback() {
        this.lifecycle?.abort();
        this.lifecycle = new AbortController();
        const start = () => this.start();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', start, { once: true, signal: this.lifecycle.signal });
        } else {
          start();
        }
      }

      start() {
        this.root = this.closest('main');
        this.hero = this.root?.querySelector('.peso-home-hero');
        this.media = this.hero?.querySelector('.peso-home-hero__media');
        this.progress = this.querySelector('.peso-home-motion__progress');
        if (!this.root || !this.hero || !this.progress) return;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = matchMedia('(min-width: 1000px) and (pointer: fine)');
        this.animations = new Map();
        this.seen = new WeakSet();
        const options = { signal: this.lifecycle.signal };
        const refresh = () => this.configure();
        this.reduced.addEventListener('change', refresh, options);
        this.desktop.addEventListener('change', refresh, options);
        document.addEventListener('shopify:section:load', refresh, options);
        document.addEventListener('shopify:section:reorder', refresh, options);
        this.root.addEventListener('focusin', event => {
          for (const [target, animation] of this.animations) {
            if (target.contains(event.target)) animation.cancel();
          }
        }, options);
        this.configure();
      }

      clearEffects() {
        this.effects?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.animations?.forEach(animation => animation.cancel());
        this.animations?.clear();
        this.media?.style.removeProperty('transform');
        if (this.progress) {
          this.progress.hidden = true;
          this.progress.style.removeProperty('transform');
        }
      }

      configure() {
        this.clearEffects();
        if (this.reduced.matches || !this.isConnected) {
          this.dataset.motion = 'reduced';
          return;
        }
        this.dataset.motion = 'active';
        this.effects = new AbortController();
        const signal = this.effects.signal;
        this.progress.hidden = false;
        this.measure = () => {
          const rect = this.hero.getBoundingClientRect();
          this.heroTop = rect.top + window.scrollY;
          this.heroHeight = Math.max(rect.height, 1);
          this.scrollRange = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
          this.queueFrame();
        };
        this.onScroll = () => this.queueFrame();
        window.addEventListener('scroll', this.onScroll, { passive: true, signal });
        window.addEventListener('resize', this.measure, { passive: true, signal });
        window.addEventListener('pageshow', this.measure, { signal });
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.measure();
        }, { signal });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.measure);
          this.resizeObserver.observe(document.body);
          this.resizeObserver.observe(this.hero);
        }
        this.measure();
        this.observeReveals();
      }

      queueFrame() {
        if (this.frame || document.hidden) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.reduced.matches || !this.isConnected) return;
          const y = window.scrollY;
          const progress = Math.max(0, Math.min(1, y / this.scrollRange));
          this.progress.style.transform = `scaleX(${progress})`;
          if (this.desktop.matches && this.media) {
            const shift = Math.max(0, Math.min(28, (y - this.heroTop) * 0.07));
            const scale = 1 + 58 / this.heroHeight;
            this.media.style.transform = `translate3d(0, ${shift.toFixed(2)}px, 0) scale(${scale.toFixed(4)})`;
          }
        });
      }

      observeReveals() {
        if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
        const selector = [
          '.peso-home-moments__intro', '.peso-home-moments__card',
          '.peso-home-featured__header', '.peso-home-featured__item',
          '.peso-home-custom__content', '.peso-home-services__grid > li',
          '.peso-home-contact__inner'
        ].join(',');
        const targets = [...this.root.querySelectorAll(selector)];
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const target = entry.target;
            this.observer.unobserve(target);
            if (this.seen.has(target) || this.reduced.matches) return;
            this.seen.add(target);
            if (entry.boundingClientRect.top < 0 || target.contains(document.activeElement)) return;
            const siblings = [...target.parentElement.children].filter(child => child.matches(selector));
            const delay = Math.min(Math.max(siblings.indexOf(target), 0), 3) * 55;
            const animation = target.animate([
              { opacity: 0.65, transform: 'translateY(16px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 650, delay, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'none' });
            this.animations.set(target, animation);
            const release = () => this.animations.delete(target);
            animation.addEventListener('finish', release, { once: true });
            animation.addEventListener('cancel', release, { once: true });
          });
        }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
        targets.forEach(target => {
          if (target.getBoundingClientRect().top < window.innerHeight * 0.94) this.seen.add(target);
          if (!this.seen.has(target)) this.observer.observe(target);
        });
      }

      disconnectedCallback() {
        this.clearEffects();
        this.lifecycle?.abort();
      }
    }
    customElements.define('peso-home-motion', PesoHomeMotion);
  }
  } catch(e) { console.error(e); }
})();

})();
